import React, { useEffect } from "react";
import {connect} from "react-redux";
import { REQUESTED_NUMBER_OF_CHATS, TRIGGER_SCROLL_HEIGHT } from "src/app/chats/chats-main/chats-list/ChatsListConstants";
import TagSearchingInput from "src/app/shared/components/tag-searching-input/TagSearchingInput";
import { useTranslation } from 'react-i18next';
import { Table } from "reactstrap";
import ChatsItem from "src/app/chats/chats-main/chats-list/chats-item/ChatsItem";
import { IApplicationState } from "src/~store/models/ApplicationState";
import { 
    channelsListSelector,
    chatsSelector, 
    isReceivingChatsSelector, 
    countOfChatsSelector, 
    searchStringForChatsListSelector,
    operatorIdSelector } from "src/app/chats/~store/selector";
import {  
    onChatItemClick,
    changeChatContactChatName,
    } from "src/app/chats/~store/actions/actions";
import { contactsSelector, isChatVisibleSelector } from "src/app/contact/~store/selector";
import { allOperatorsSelector } from "src/app/operator/~store/selector";
import { ISearchingTag } from "src/app/shared/components/tag-searching-input/~types/models/SearchingTag";
import { GetChatsMode } from "src/app/chats/~store/models/enums/GetChatsMode";
import { IContact } from "src/app/contact/~store/models/Contact";
import { IMailingRecipientsChatListProps } from "./~types/MailingRecipientsChatListProps";
import { getContacts } from "src/app/contact/~store/actions/actions";
import { getAllChannels } from "src/app/channel/~store/actions/actions";
import { getAllOperators } from "src/app/operator/~store/actions/actions";
import { getTimePassedFromDate } from "src/app/shared/helpers/date-helper/DateHelper";
import Loader from "src/app/shared/components/loader/Loader";
import { IMessage } from "src/app/chats/~store/models/Message";
import { MessageType } from 'src/app/chats/~store/models/enums/MessageType';

import "./MailingRecipientsChatList.css";
import { getChatsForMailing, searchChatsForMailing } from "src/app/mailing/~store/actions/actions";
import { mailingItemInfoSelector } from "src/app/mailing/~store/selector";
import { SEARCHING_TAGS_FOR_MAILING_CHAT_LIST } from "./MailingRecipientsChatListConstants";
import { sLColorSecondsSettingsSelector } from "src/app/setting/~store/selector";

type ReduxType = ReturnType<typeof mapStateToProps> & IMailingRecipientsChatListProps;

const MailingRecipientsChatList = (props: ReduxType) => {
    const { t } = useTranslation();

    let canLoadOnScroll = true;

    useEffect(() => {
        props.searchChats(props.mailingItemInfo.searchingTagsForChats ?? []);
    }, []);

    const _onClearFilter = () => {
        props.searchChats([]);
    }
    
    const onChatsScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
        if ((e.currentTarget.scrollHeight - e.currentTarget.scrollTop - e.currentTarget.clientHeight) <= TRIGGER_SCROLL_HEIGHT && !props.isReceivingChats && canLoadOnScroll) {
            canLoadOnScroll = true;
            props.getChats(props.countOfChats, REQUESTED_NUMBER_OF_CHATS, props.searchString, props.mailingItemInfo.searchingTagsForChats);
            canLoadOnScroll = false;
        }
    }

    return (
        <div>
            <TagSearchingInput
                searchingTags={SEARCHING_TAGS_FOR_MAILING_CHAT_LIST}
                operators={props.operators}
                contacts={props.contacts}
                channels={props.channels}
                getAllChannels={props.getAllChannels}
                getAllOperators={props.getAllOperators}
                getContacts={(searchingString) => props.getContacts(0, 5, searchingString ?? "", true, true)}
                onSearch={(tags) => props.searchChats(tags)}
                currentTags={props.mailingItemInfo.searchingTagsForChats ?? []}
                onClearFilter={() => _onClearFilter()} />
            <div 
                onScroll={onChatsScroll} 
                className={`chats-list__body ${(props.isChatVisible ? "splittered" : "")}`}>
                {GetChatsTable(props)}
                {props.isReceivingChats && <Loader/>}
            </div>
        </div>
        
    );
}

const GetChatsTable = (props: ReduxType): React.ReactElement<{}> => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            {(props.chats.length > 0) && 
                <Table className="chats-list-table card-table">
                    <thead>
                        <tr>
                            <th className="chat-item__channel-info-cell">
                                {t('common.contact')}
                            </th>
                            <th style={props.isChatVisible ? {} : { float: "right" }}>{t('chats.info')}</th>
                            {!props.isChatVisible && <th></th>}
                            {<th>{t('common.status')}</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {props.chats.map((chat, index) => {
                            return (
                                <ChatsItem 
                                    chat={chat} 
                                    key={`${chat.chatId}-${index}`}
                                    sender={getOperatorName(chat.lastMessage, props.operatorId)}
                                    onClick={(chatId) => { if(chatId !== props.selectedChatId || !props.isChatVisible) props.onChatItemClick(chatId)}}
                                    selected={chat.chatId === props.selectedChatId}
                                    isChatvisible={props.isChatVisible}
                                    operatorId={props.operatorId}
                                    changeChatContactChatname={props.changeChatContactChatname}
                                    chatsMode={GetChatsMode.forMailing}
                                    firstNotAnsweredMessage={chat.firstNotAnsweredMessage}
                                    sLColorSecondsSettings={props.sLColorSecondsSettings}
                                    pausedTime={chat.lastPausedTime ? getTimePassedFromDate(chat.lastPausedTime) : ''}
                                    contact={chat.contact}
                                />
                            )
                        })}
                    </tbody>
                </Table>
            }
        </React.Fragment>
    )
}

const getOperatorName = (message: IMessage, myId : number): string | null => {
    if(message && message.operatorName) {
        if(message.messageType === MessageType.ClientMessage)
            return null;
        if(message.operatorId === myId) {
            return "Вы";
        }
        return message.operatorName;
    }
    return null;
}

const mapStateToProps = (state: IApplicationState) => {
    return {
        mailingItemInfo: mailingItemInfoSelector(state),
        channels: channelsListSelector(state),
        chats: chatsSelector(state),
        isReceivingChats: isReceivingChatsSelector(state),
        countOfChats: countOfChatsSelector(state),
        searchString: searchStringForChatsListSelector(state),
        operatorId: operatorIdSelector(state),
        sLColorSecondsSettings: sLColorSecondsSettingsSelector(state),
        isChatVisible: isChatVisibleSelector(state),
        selectedChatId: state.chatItemsState.selectedChatId,
        operators: allOperatorsSelector(state),
        contacts: contactsSelector(state)
    };
}

const mapDispatchToProps = (dispatch: any): IMailingRecipientsChatListProps => {
    return {
        getAllChannels: () => dispatch(getAllChannels()),
        getChats: (
            skip: number, 
            count: number, 
            searchString: string,
            tags: ISearchingTag[]
        ) => dispatch(getChatsForMailing(skip, count, searchString, tags)),
        onChatItemClick: (chatId: number) => { return onChatItemClick(chatId)},
        changeChatContactChatname: (
            contact: IContact, 
            chatId: number
        ) => dispatch(changeChatContactChatName(contact, chatId)),
        getAllOperators: () => dispatch(getAllOperators()),
        getContacts: (
            skip: number, 
            count: number, 
            searchString: string | undefined, 
            isSortingByContactLastName: boolean
        ) => dispatch(getContacts(skip, count, searchString, isSortingByContactLastName, true)),
        searchChats: (
            tags: ISearchingTag[]
        ) => dispatch(searchChatsForMailing(tags))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MailingRecipientsChatList);